<div class="dev_fund">
    <div class="title">
        <p>{{ title }}</p>
    </div>
    <div class="details">
        <div class="amount">{{ amount | moneyParse | bitNumber }} INF</div>
    </div>
</div>
